import { useState } from 'react';
import { countryFlag } from '../lib/format.js';

export default function UrlForm({ countries, onCheck, busy }) {
  const [url, setUrl] = useState('');
  const [country, setCountry] = useState('');

  const submit = (event) => {
    event.preventDefault();
    const trimmed = url.trim();
    if (!trimmed) return;
    onCheck(trimmed, country || null);
  };

  return (
    <form className="form" onSubmit={submit}>
      <div className="form__row">
        <div className="form__field" style={{ flex: '3 1 320px' }}>
          <label className="form__label" htmlFor="url">
            Link to open
          </label>
          <input
            id="url"
            className="input"
            type="text"
            inputMode="url"
            autoComplete="off"
            placeholder="https://example.com/restricted-page"
            value={url}
            onChange={(event) => setUrl(event.target.value)}
          />
        </div>

        <div className="form__field" style={{ flex: '1 1 180px' }}>
          <label className="form__label" htmlFor="country">
            Open from
          </label>
          <select
            id="country"
            className="select"
            value={country}
            onChange={(event) => setCountry(event.target.value)}
          >
            <option value="">Auto — fastest healthy node</option>
            {countries.map((entry) => (
              <option
                key={entry.country}
                value={entry.country}
                disabled={entry.healthyNodes === 0}
              >
                {countryFlag(entry.country)} {entry.countryName}
                {entry.healthyNodes === 0 ? ' (no healthy node)' : ` (${entry.healthyNodes})`}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <button className="btn" type="submit" disabled={busy || !url.trim()}>
          {busy && <span className="spinner" />}
          {busy ? 'Checking…' : 'Check & open'}
        </button>
      </div>
    </form>
  );
}
